export const currencyChoices = [
  { id: "USD", name: "USD - US Dollar" },
  { id: "EUR", name: "EUR - Euro" },
  { id: "COP", name: "COP - Colombian Peso" },
  { id: "MXN", name: "MXN - Mexican Peso" },
  { id: "PEN", name: "PEN - Peruvian Sol" },
  { id: "PAB", name: "PAB - Panamanian Balboa" },
  { id: "ARS", name: "ARS - Argentine Peso" },
  { id: "CLP", name: "CLP - Chilean Peso" },
  { id: "UYU", name: "UYU - Uruguayan Peso" },
  { id: "PYG", name: "PYG - Paraguayan Guaraní" },
  { id: "BOB", name: "BOB - Bolivian Boliviano" },
  { id: "VES", name: "VES - Venezuelan Bolívar" },
  { id: "BRL", name: "BRL - Brazilian Real" },
  { id: "GTQ", name: "GTQ - Guatemalan Quetzal" },
  { id: "HNL", name: "HNL - Honduran Lempira" },
  { id: "NIO", name: "NIO - Nicaraguan Córdoba" },
  { id: "CRC", name: "CRC - Costa Rican Colón" },
  { id: "SVC", name: "SVC - Salvadoran Colón" },
  { id: "BZD", name: "BZD - Belize Dollar" },
  { id: "DOP", name: "DOP - Dominican Peso" }
] as const;

export type CurrencyCode = typeof currencyChoices[number]["id"];

